export default {
      id: "league-silver-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#league-silver",
      toString: function () {
        return this.url;
      }
    }